module.exports = __webpack_public_path__ + "static/media/header-canfax.5367333d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-canfax.png
// module id = 106
// module chunks = 0